export const AgentNames = {
  greetings: '',
  onboarding_assistant: 'Onboarding Assistant',
  methodology_assistant: 'Methodology Assistant',
  create_experiment_form_filler: 'Create Experiment Assistant',
  kpi_assistant: 'KPI Assistant',
  bpd_assistant: 'Best Practices Decoded Assistant',
  smart_query_agent: 'Smart Query Agent',
}
